<template>
  <div class="reorder-item">
    <div class="reorder-header">
      <div class="flex justify-between">
        <div class="flex">
          <div class="header-data-item">
            <h4>DATE</h4>
            <p>{{ reorder.suborder.order_date | moment("MMM DD, YYYY") }}</p>
          </div>
          <div class="header-data-item hidden-on-mobile">
            <h4>ORDER</h4>
            <p>B-{{ reorder.suborder.order_number }}</p>
          </div>
          <div class="header-data-item hidden-on-mobile">
            <h4>SUBORDER</h4>
            <p>S-{{ reorder.suborder.suborder_number }}</p>
          </div>
        </div>
        <router-link
          class="order-details-link"
          :to="{
            name: 'orderDetailsRetailer',
            params: {
              orderId: reorder.suborder.order_id,
            },
            query: {
              suborderId: reorder.suborder.id,
            },
          }"
          >See Order Details</router-link
        >
      </div>
    </div>

    <div class="brand-section">
      <reorder-brand-bio
        :on-follow-click="onFollowClick"
        :brand-id="reorder.brand.id"
        :brand-name="reorder.brand.name"
        :brand-image-url="reorder.brand.image"
        :vanity-url="reorder.brand.vanity_url_name"
        :minimum-reorder-value="reorder.brand.minimum_reorder_value"
        :is-brand-favourite="reorder.brand.isBrandFavourite"
      />
    </div>

    <div class="variants-grid">
      <template
        v-for="{
          image,
          productName,
          variantName,
          originalQuantity,
          isFavorite,
          productId,
          variantId,
          trackInventory,
          inStock,
          inventoryQuantity,
          increment,
          minimum,
          price,
          deleted,
        } in variants"
      >
        <reorder-variant-tile
          :image="image"
          :product-name="productName"
          :product-id="productId"
          :is-favorite="isFavorite"
          :variant-name="variantName"
          :original-quantity="originalQuantity"
          :variant-id="variantId"
          :track-inventory="trackInventory"
          :in-stock="inStock"
          :inventory-quantity="inventoryQuantity"
          :increment="increment"
          :minimum="minimum"
          :price="price"
          :deleted="deleted"
        />
      </template>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/sass/base/_vars.scss";
@import "@/assets/sass/base/_mixins.scss";

.reorder-item {
  padding-block: 24px;
  border-block: 1px solid $color-grey;
  margin-bottom: 24px;
}

.reorder-header {
  background: $color-light-grey;
  padding: 24px;

  .header-data-item {
    margin-right: 36px;
    h4 {
      font-size: 12px;
    }

    p {
      margin-top: 8px;
      font-size: 16px;
      font-family: NHaasGroteskDSPro-55Rg;
    }

    &.hidden-on-mobile {
      @include respond-to("small") {
        display: none;
      }
    }
  }

  .order-details-link {
    font-size: 16px;
    font-family: NHaasGroteskDSPro-55Rg;
    text-decoration: underline;

    &:hover {
      cursor: pointer;
    }
  }
}

.brand-section {
  margin-block: 24px;
  display: flex;

  @include respond-to("small") {
    display: block;
  }
}

.variants-grid {
  display: grid;
  width: 100%;
  grid-row-gap: 40px;
  grid-column-gap: 24px !important;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  margin-bottom: 24px;

  @include respond-to("medium") {
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 16px;
    grid-row-gap: 40px;
  }

  @include respond-to("small") {
    display: flex;
    overflow: auto;
    width: calc(100% + 16px);
    padding-right: 16px;
    grid-column-gap: 16px !important;
  }
}
</style>

<script>
import ReorderBrandBio from "./reorderBrandBio";
import ReorderVariantTile from "./reorderVariantTile";
import { mapGetters } from "vuex";
import { reorderPageHelper } from "./reorderPageHelper";

export default {
  mixins: [reorderPageHelper],
  components: { ReorderVariantTile, ReorderBrandBio },
  props: {
    reorder: {
      type: Object,
      default: null,
    },
    isBrandFavorite: {
      type: Boolean,
      default: false,
    },
    onFollowClick: {
      type: Function,
      default: () => null,
    },
  },
  computed: {
    ...mapGetters({
      favoriteProducts: "favoriteProductsState",
    }),
    variants() {
      return this.mapReorderToVariantList(this.reorder);
    },
  },
};
</script>
